
import { Component, Vue, Watch, Prop, Ref, Emit, Model } from "vue-property-decorator";
import ImageViewer from "./ImageViewer.vue";
import OCROrderApi from "@/api/ocr-order-api";
import Config from "./config"
import Filter from "~/utils/filter"
import { Toast } from "vant";
type MainType = { mpq: number, pcs: number, other: number, mpqUnit: string }
const Units = [

    // { key: OCROrderApi.PackagingUnit.Box, value: "盒" },
    { key: OCROrderApi.PackagingUnit.Bag, value: "袋" },
    { key: OCROrderApi.PackagingUnit.Case, value: "箱" },
    { key: OCROrderApi.PackagingUnit.Reel, value: "盘" }
] as ZnlOptions[]
type PackageInfo = OCROrderApi.IReceiptPackagingInfo

@Component({ name: "item-editor-qty", components: { ImageViewer } })
export default class ItemEditorQty extends Vue {
    qtyInfo: MainType = { mpq: undefined, pcs: 1, other: undefined, mpqUnit: '盘' } as any
    innerPackage: PackageInfo[] = []
    allUnits = Units
    filterFunc = Filter;
    get mpq() {
        if (this.innerPackage.length == 0) return undefined;
        return Number(this.innerPackage[0].Qty) as any || undefined;
    }

    set mpq(v: NString) {
        //console.error("mpq set ", v);
        if (this.innerPackage.length == 0) this.packages.push({ Qty: 0, PCS: 1, Type: Config.DefaultMpqUnitType } as any)
        this.innerPackage[0].Qty = Number(v) || 0;
        this.updatePackage();
    }
    get pcs() {
        if (this.innerPackage.length == 0) return undefined;
        return Number(this.innerPackage[0].PCS) as any || undefined;
    }
    set pcs(v: NString) {
        if (this.innerPackage.length == 0) this.innerPackage.push({ Qty: 0, PCS: 1, Type: Config.DefaultMpqUnitType } as any)
        this.innerPackage[0].PCS = Number(v) || 0;
        this.updatePackage();
    }

    get otherQty() {
        var r;
        if (this.innerPackage.length > 1)
            r = Number(this.innerPackage[1].Qty) as any || undefined;
        // console.error("get otherQty ", r, this.innerPackage)
        return r;
    }

    set otherQty(v: NString) {
        if (this.innerPackage.length < 1) this.innerPackage.push({ Qty: undefined, PCS: undefined, Type: Config.DefaultMpqUnitType } as any)
        if (this.innerPackage.length < 2) this.innerPackage.push({ Qty: 0, PCS: 1, Type: 0 } as any)
        this.innerPackage[1].Qty = Number(v) || 0;
        this.innerPackage[1].PCS = 1;
        this.updatePackage();
    }

    get mpqUnit() {
        var defUnit = undefined;
        if (this.packages.length == 0) return defUnit;
        return Units.find(e => e.key == this.packages[0].Type)?.value || defUnit
    }


    get totalQty() {
        return Array.sum(this.innerPackage, e => e.Qty * e.PCS * (e.AsKilo ? 1000 : 1) || 0);
    }



    @Prop()
    packages!: PackageInfo[]

    @Model("update:value")
    value!: number

    unitOnClick(u: ZnlOptions) {
        var p = this.ensurePackages(1, undefined as any);
        p.Type = u.key || 0;
        this.updatePackage();
    }

    ensurePackages(count: number, pcs: number) {
        if (this.innerPackage.length >= count) return this.packages[count - 1];
        for (var idx = this.innerPackage.length; idx < count; idx++) {
            const Type = idx = 0 ? Config.DefaultMpqUnitType : 0;
            this.innerPackage.push({ Qty: undefined, PCS: undefined, Type } as any)
        }
        this.innerPackage[count - 1].PCS = pcs;
        return this.innerPackage[count - 1];
    }


    @Watch("packages", { immediate: true })
    packagesChange() {
        var pk = Config.oldPackageConvert(this.packages)!;
        if (pk != this.packages) {
            if (this.value && this.totalQty != this.value) {
                Toast({ message: '数量合计异常', icon: 'warning' })
                // console.error("数量合计异常", JSON.stringify(this.packages), this.value, this.totalQty)
                pk = [
                    { PCS: 1, Qty: undefined as any, AsKilo: false, Type: OCROrderApi.PackagingUnit.Reel, AgentOrderDetailReceiptInfoId: 0 },
                    { PCS: 1, Qty: this.value, AsKilo: false, Type: 0, AgentOrderDetailReceiptInfoId: 0 }
                ];
            }
        }

        this.innerPackage = pk;
        // console.error(this.innerPackage)
    }

    updatePackage() {

        if (this.packages == this.innerPackage) return;
        // console.error("updatePackage ", JSON.stringify(this.innerPackage))
        this.$emit("update:packages", this.innerPackage);
    }
}

